import { relations } from 'drizzle-orm/relations';
import {
  articlesOfAssocs,
  articlesOfAssocDocuments,
  snrCases,
  authorizationGroups,
  snrAuthorizations,
  authorizationGroupDocuments,
  authorizations,
  capTables,
  meetings,
  agendaItems,
  agendaItemDecisions,
  authKeys,
  capTableStakes,
  authorizationMeetings,
  companyDirectors,
  companySuggestions,
  companySubscriptions,
  cooptedMeetingParticipants,
  documentAppendices,
  emails,
  issuanceProgramParticipants,
  ippStripePayments,
  stripePayments,
  investmentGrants,
  issuancePrograms,
  stripePaymentConfigs,
  fidoKeys,
  optionsRegistrationSignatories,
  optionsRegistrations,
  meetingParticipants,
  meetingParticipantShares,
  niceFounders,
  meetingSummonsAttachments,
  meetingConcerns,
  shareIssues,
  meetingAgendaTemplates,
  meetingApprovals,
  meetingDocuments,
  meetingTodos,
  todos,
  meetingParticipantDocuments,
  meetingParticipantEmails,
  optionsRegistrationDocuments,
  optionsSharesRegistrations,
  optionsSharesRegistrationDocuments,
  optionsSharesSubscribers,
  optionsSharesSubscriberRepresentatives,
  shareIssueParticipants,
  shareIssueParticipantDocuments,
  shareIssueRegistrations,
  shareIssueRegistrationDocuments,
  snrShareCapitalChanges,
  shareIssueBoardMembers,
  optionsSharesSubscriberDocuments,
  optionsSubscriberRepresentatives,
  shareIssueDocuments,
  shareTransactions,
  shareTransactionGroups,
  shareTransactionDocuments,
  snrBonds,
  snrDocuments,
  snrOcrExtracts,
  shareSubscriptions,
  webAuthnKeys,
  wiseDependencyBonds,
  warrantBoardMembers,
  meetingAgendaTemplateItems,
} from './initial';
import { companies } from './companies';
import { users } from './users';
import { files, fileFolderFields } from './files';
import { shareholders } from './shareholders';
import { documentSignatures } from './document-signatures';
import { identities } from './identities';
import { registrationTodoCompletions } from './registration_todos';
import {
  warrantProgramParticipants,
  warrantPrograms,
  warrantShareholders,
  warrantParticipantDocuments,
  warrantParticipantVestingOccasions,
} from './warrant_programs';
export const articlesOfAssocDocumentsRelations = relations(articlesOfAssocDocuments, ({ one }) => ({
  articlesOfAssoc: one(articlesOfAssocs, {
    fields: [articlesOfAssocDocuments.articlesOfAssocId],
    references: [articlesOfAssocs.id],
  }),
  file: one(files, {
    fields: [articlesOfAssocDocuments.fileId],
    references: [files.id],
  }),
}));

export const articlesOfAssocsRelations = relations(articlesOfAssocs, ({ one, many }) => ({
  articlesOfAssocDocuments: many(articlesOfAssocDocuments),
  company: one(companies, {
    fields: [articlesOfAssocs.companyId],
    references: [companies.id],
  }),
  identity_contactId: one(identities, {
    fields: [articlesOfAssocs.contactId],
    references: [identities.id],
    relationName: 'articlesOfAssocs_contactId_identities_id',
  }),
  identity_signatoryId: one(identities, {
    fields: [articlesOfAssocs.signatoryId],
    references: [identities.id],
    relationName: 'articlesOfAssocs_signatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [articlesOfAssocs.snrCaseId],
    references: [snrCases.id],
  }),
  meetingConcerns: many(meetingConcerns),
}));

export const filesRelations = relations(files, ({ one, many }) => ({
  articlesOfAssocDocuments: many(articlesOfAssocDocuments),
  authorizationGroupDocuments: many(authorizationGroupDocuments),
  documentAppendices_appendixId: many(documentAppendices, {
    relationName: 'documentAppendices_appendixId_files_id',
  }),
  documentAppendices_fileId: many(documentAppendices, {
    relationName: 'documentAppendices_fileId_files_id',
  }),
  documentSignatures: many(documentSignatures),
  file: one(files, {
    fields: [files.parentId],
    references: [files.id],
    relationName: 'files_parentId_files_id',
  }),
  files: many(files, {
    relationName: 'files_parentId_files_id',
  }),
  company: one(companies, {
    fields: [files.companyId],
    references: [companies.id],
  }),
  investmentGrants: many(investmentGrants),
  meetingSummonsAttachments: many(meetingSummonsAttachments),
  meetingDocuments: many(meetingDocuments),
  meetingParticipantDocuments: many(meetingParticipantDocuments),
  meetingParticipantEmails: many(meetingParticipantEmails),
  optionsRegistrationDocuments: many(optionsRegistrationDocuments),
  optionsSharesRegistrationDocuments: many(optionsSharesRegistrationDocuments),
  shareIssueParticipantDocuments: many(shareIssueParticipantDocuments),
  shareIssueRegistrationDocuments: many(shareIssueRegistrationDocuments),
  optionsSharesSubscriberDocuments: many(optionsSharesSubscriberDocuments),
  shareIssueDocuments: many(shareIssueDocuments),
  shareTransactionDocuments: many(shareTransactionDocuments),
  warrantParticipantDocuments: many(warrantParticipantDocuments),
}));

export const snrCasesRelations = relations(snrCases, ({ one, many }) => ({
  articlesOfAssocs: many(articlesOfAssocs),
  authorizationGroups: many(authorizationGroups),
  optionsSharesRegistrations: many(optionsSharesRegistrations),
  shareIssues: many(shareIssues),
  shareIssueRegistrations: many(shareIssueRegistrations),
  company: one(companies, {
    fields: [snrCases.companyId],
    references: [companies.id],
  }),
  warrantPrograms: many(warrantPrograms),
  optionsRegistrations: many(optionsRegistrations),
}));

export const authorizationGroupsRelations = relations(authorizationGroups, ({ one, many }) => ({
  identity_contactId: one(identities, {
    fields: [authorizationGroups.contactId],
    references: [identities.id],
    relationName: 'authorizationGroups_contactId_identities_id',
  }),
  identity_signatoryId: one(identities, {
    fields: [authorizationGroups.signatoryId],
    references: [identities.id],
    relationName: 'authorizationGroups_signatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [authorizationGroups.snrCaseId],
    references: [snrCases.id],
  }),
  company: one(companies, {
    fields: [authorizationGroups.companyId],
    references: [companies.id],
  }),
  snrAuthorization: one(snrAuthorizations, {
    fields: [authorizationGroups.snrAuthorizationId],
    references: [snrAuthorizations.id],
  }),
  authorizationGroupDocuments: many(authorizationGroupDocuments),
  authorizations: many(authorizations),
  authorizationMeetings: many(authorizationMeetings),
  meetingConcerns: many(meetingConcerns),
  meetings: many(meetings),
}));

export const snrAuthorizationsRelations = relations(snrAuthorizations, ({ one, many }) => ({
  authorizationGroups: many(authorizationGroups),
  shareIssues: many(shareIssues),
  company: one(companies, {
    fields: [snrAuthorizations.companyId],
    references: [companies.id],
  }),
  warrantPrograms: many(warrantPrograms),
}));

export const authorizationGroupDocumentsRelations = relations(authorizationGroupDocuments, ({ one }) => ({
  authorizationGroup: one(authorizationGroups, {
    fields: [authorizationGroupDocuments.authorizationGroupId],
    references: [authorizationGroups.id],
  }),
  file: one(files, {
    fields: [authorizationGroupDocuments.fileId],
    references: [files.id],
  }),
}));

export const authorizationsRelations = relations(authorizations, ({ one }) => ({
  authorizationGroup: one(authorizationGroups, {
    fields: [authorizations.authorizationGroupId],
    references: [authorizationGroups.id],
  }),
}));

export const capTablesRelations = relations(capTables, ({ one, many }) => ({
  company: one(companies, {
    fields: [capTables.companyId],
    references: [companies.id],
  }),
  capTableStakes: many(capTableStakes),
}));

export const agendaItemsRelations = relations(agendaItems, ({ one, many }) => ({
  meeting: one(meetings, {
    fields: [agendaItems.meetingId],
    references: [meetings.id],
  }),
  agendaItemDecisions: many(agendaItemDecisions),
}));

export const meetingsRelations = relations(meetings, ({ one, many }) => ({
  agendaItems: many(agendaItems),
  authorizationMeetings: many(authorizationMeetings),
  meetingSummonsAttachments: many(meetingSummonsAttachments),
  meetingConcerns: many(meetingConcerns),
  meetingApprovals: many(meetingApprovals),
  meetingDocuments: many(meetingDocuments),
  meetingParticipants: many(meetingParticipants),
  meetingTodos: many(meetingTodos),
  company: one(companies, {
    fields: [meetings.companyId],
    references: [companies.id],
  }),
  authorizationGroup: one(authorizationGroups, {
    fields: [meetings.authorizationId],
    references: [authorizationGroups.id],
  }),
  meeting: one(meetings, {
    fields: [meetings.createdByMeeting],
    references: [meetings.id],
    relationName: 'meetings_createdByMeeting_meetings_id',
  }),
  meetings: many(meetings, {
    relationName: 'meetings_createdByMeeting_meetings_id',
  }),
  shareIssues: many(shareIssues),
  warrantPrograms: many(warrantPrograms),
}));

export const agendaItemDecisionsRelations = relations(agendaItemDecisions, ({ one }) => ({
  agendaItem: one(agendaItems, {
    fields: [agendaItemDecisions.agendaItemId],
    references: [agendaItems.id],
  }),
}));

export const authKeysRelations = relations(authKeys, ({ one }) => ({
  user: one(users, {
    fields: [authKeys.userId],
    references: [users.id],
  }),
}));

export const capTableStakesRelations = relations(capTableStakes, ({ one }) => ({
  capTable: one(capTables, {
    fields: [capTableStakes.capTableId],
    references: [capTables.id],
  }),
  identity: one(identities, {
    fields: [capTableStakes.identityId],
    references: [identities.id],
  }),
  warrantProgramParticipant: one(warrantProgramParticipants, {
    fields: [capTableStakes.warrantParticipantId],
    references: [warrantProgramParticipants.id],
  }),
}));

export const warrantProgramParticipantsRelations = relations(warrantProgramParticipants, ({ one, many }) => ({
  capTableStakes: many(capTableStakes),
  optionsSubscriberRepresentatives: many(optionsSubscriberRepresentatives),
  warrantParticipantDocuments: many(warrantParticipantDocuments),
  warrantParticipantVestingOccasions: many(warrantParticipantVestingOccasions),
  warrantProgram: one(warrantPrograms, {
    fields: [warrantProgramParticipants.delWarrantProgramId],
    references: [warrantPrograms.id],
  }),
  identity: one(identities, {
    fields: [warrantProgramParticipants.identityId],
    references: [identities.id],
  }),
  optionsRegistration: one(optionsRegistrations, {
    fields: [warrantProgramParticipants.optionsRegistrationId],
    references: [optionsRegistrations.id],
  }),
}));

export const authorizationMeetingsRelations = relations(authorizationMeetings, ({ one }) => ({
  authorizationGroup: one(authorizationGroups, {
    fields: [authorizationMeetings.authorizationId],
    references: [authorizationGroups.id],
  }),
  meeting: one(meetings, {
    fields: [authorizationMeetings.meetingId],
    references: [meetings.id],
  }),
}));

export const companyDirectorsRelations = relations(companyDirectors, ({ one }) => ({
  identity: one(identities, {
    fields: [companyDirectors.identityId],
    references: [identities.id],
  }),
  company: one(companies, {
    fields: [companyDirectors.companyId],
    references: [companies.id],
  }),
}));

export const companySuggestionsRelations = relations(companySuggestions, ({ one }) => ({
  user: one(users, {
    fields: [companySuggestions.userId],
    references: [users.id],
  }),
}));

export const companySubscriptionsRelations = relations(companySubscriptions, ({ one }) => ({
  company: one(companies, {
    fields: [companySubscriptions.companyId],
    references: [companies.id],
  }),
}));

export const cooptedMeetingParticipantsRelations = relations(cooptedMeetingParticipants, ({ one }) => ({
  company: one(companies, {
    fields: [cooptedMeetingParticipants.companyId],
    references: [companies.id],
  }),
  identity: one(identities, {
    fields: [cooptedMeetingParticipants.identityId],
    references: [identities.id],
  }),
}));

export const documentAppendicesRelations = relations(documentAppendices, ({ one }) => ({
  file_appendixId: one(files, {
    fields: [documentAppendices.appendixId],
    references: [files.id],
    relationName: 'documentAppendices_appendixId_files_id',
  }),
  file_fileId: one(files, {
    fields: [documentAppendices.fileId],
    references: [files.id],
    relationName: 'documentAppendices_fileId_files_id',
  }),
}));

export const emailsRelations = relations(emails, ({ one, many }) => ({
  company: one(companies, {
    fields: [emails.companyId],
    references: [companies.id],
  }),
  meetingParticipantEmails: many(meetingParticipantEmails),
}));

export const ippStripePaymentsRelations = relations(ippStripePayments, ({ one }) => ({
  issuanceProgramParticipant: one(issuanceProgramParticipants, {
    fields: [ippStripePayments.issuanceProgramParticipantId],
    references: [issuanceProgramParticipants.id],
  }),
  stripePayment: one(stripePayments, {
    fields: [ippStripePayments.stripePaymentId],
    references: [stripePayments.id],
  }),
}));

export const issuanceProgramParticipantsRelations = relations(issuanceProgramParticipants, ({ one, many }) => ({
  ippStripePayments: many(ippStripePayments),
  identity: one(identities, {
    fields: [issuanceProgramParticipants.identityId],
    references: [identities.id],
  }),
  issuanceProgram: one(issuancePrograms, {
    fields: [issuanceProgramParticipants.issuanceProgramId],
    references: [issuancePrograms.id],
  }),
}));

export const stripePaymentsRelations = relations(stripePayments, ({ many }) => ({
  ippStripePayments: many(ippStripePayments),
}));

export const investmentGrantsRelations = relations(investmentGrants, ({ one }) => ({
  file: one(files, {
    fields: [investmentGrants.fileId],
    references: [files.id],
  }),
  shareholder: one(shareholders, {
    fields: [investmentGrants.shareholderId],
    references: [shareholders.id],
  }),
}));

export const issuanceProgramsRelations = relations(issuancePrograms, ({ one, many }) => ({
  company: one(companies, {
    fields: [issuancePrograms.companyId],
    references: [companies.id],
  }),
  stripePaymentConfig: one(stripePaymentConfigs, {
    fields: [issuancePrograms.stripePaymentConfigId],
    references: [stripePaymentConfigs.id],
  }),
  issuanceProgramParticipants: many(issuanceProgramParticipants),
}));

export const stripePaymentConfigsRelations = relations(stripePaymentConfigs, ({ many }) => ({
  issuancePrograms: many(issuancePrograms),
}));

export const fidoKeysRelations = relations(fidoKeys, ({ one }) => ({
  user: one(users, {
    fields: [fidoKeys.userId],
    references: [users.id],
  }),
}));

export const optionsRegistrationSignatoriesRelations = relations(optionsRegistrationSignatories, ({ one }) => ({
  identity: one(identities, {
    fields: [optionsRegistrationSignatories.identityId],
    references: [identities.id],
  }),
  optionsRegistration: one(optionsRegistrations, {
    fields: [optionsRegistrationSignatories.optionsRegistrationId],
    references: [optionsRegistrations.id],
  }),
}));

export const optionsRegistrationsRelations = relations(optionsRegistrations, ({ one, many }) => ({
  optionsRegistrationSignatories: many(optionsRegistrationSignatories),
  optionsRegistrationDocuments: many(optionsRegistrationDocuments),
  identity_contactId: one(identities, {
    fields: [optionsRegistrations.contactId],
    references: [identities.id],
    relationName: 'optionsRegistrations_contactId_identities_id',
  }),
  identity_signatoryId: one(identities, {
    fields: [optionsRegistrations.signatoryId],
    references: [identities.id],
    relationName: 'optionsRegistrations_signatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [optionsRegistrations.snrCaseId],
    references: [snrCases.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [optionsRegistrations.warrantProgramId],
    references: [warrantPrograms.id],
  }),
  warrantProgramParticipants: many(warrantProgramParticipants),
  todos: many(registrationTodoCompletions),
}));

export const meetingParticipantSharesRelations = relations(meetingParticipantShares, ({ one }) => ({
  meetingParticipant: one(meetingParticipants, {
    fields: [meetingParticipantShares.meetingParticipantId],
    references: [meetingParticipants.id],
  }),
}));

export const meetingParticipantsRelations = relations(meetingParticipants, ({ one, many }) => ({
  meetingParticipantShares: many(meetingParticipantShares),
  meetingApprovals: many(meetingApprovals),
  meeting: one(meetings, {
    fields: [meetingParticipants.meetingId],
    references: [meetings.id],
  }),
  identity_identityId: one(identities, {
    fields: [meetingParticipants.identityId],
    references: [identities.id],
    relationName: 'meetingParticipants_identityId_identities_id',
  }),
  identity_proxyId: one(identities, {
    fields: [meetingParticipants.proxyId],
    references: [identities.id],
    relationName: 'meetingParticipants_proxyId_identities_id',
  }),
  meetingParticipantDocuments: many(meetingParticipantDocuments),
  meetingParticipantEmails: many(meetingParticipantEmails),
}));

export const niceFoundersRelations = relations(niceFounders, ({ one }) => ({
  identity: one(identities, {
    fields: [niceFounders.identityId],
    references: [identities.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [niceFounders.warrantProgramId],
    references: [warrantPrograms.id],
  }),
}));

export const warrantProgramsRelations = relations(warrantPrograms, ({ one, many }) => ({
  niceFounders: many(niceFounders),
  meetingConcerns_employeeOptionId: many(meetingConcerns, {
    relationName: 'meetingConcerns_employeeOptionId_warrantPrograms_id',
  }),
  meetingConcerns_warrantProgramId: many(meetingConcerns, {
    relationName: 'meetingConcerns_warrantProgramId_warrantPrograms_id',
  }),
  optionsSharesRegistrations: many(optionsSharesRegistrations),
  shareTransactionGroups: many(shareTransactionGroups),
  company: one(companies, {
    fields: [warrantPrograms.companyId],
    references: [companies.id],
  }),
  identity_contactId: one(identities, {
    fields: [warrantPrograms.contactId],
    references: [identities.id],
    relationName: 'warrantPrograms_contactId_identities_id',
  }),
  meeting: one(meetings, {
    fields: [warrantPrograms.meetingId],
    references: [meetings.id],
  }),
  identity_signatoryId: one(identities, {
    fields: [warrantPrograms.signatoryId],
    references: [identities.id],
    relationName: 'warrantPrograms_signatoryId_identities_id',
  }),
  snrAuthorization: one(snrAuthorizations, {
    fields: [warrantPrograms.snrAuthorizationId],
    references: [snrAuthorizations.id],
  }),
  snrBond: one(snrBonds, {
    fields: [warrantPrograms.snrBondId],
    references: [snrBonds.id],
  }),
  snrCase: one(snrCases, {
    fields: [warrantPrograms.snrCaseId],
    references: [snrCases.id],
  }),
  snrShareCapitalChange: one(snrShareCapitalChanges, {
    fields: [warrantPrograms.valuationSccId],
    references: [snrShareCapitalChanges.id],
  }),
  shareIssue: one(shareIssues, {
    fields: [warrantPrograms.valuationShareIssueId],
    references: [shareIssues.id],
  }),
  warrantShareholders: many(warrantShareholders),
  wiseDependencyBonds: many(wiseDependencyBonds),
  warrantBoardMembers: many(warrantBoardMembers),
  optionsRegistrations: many(optionsRegistrations),
  warrantProgramParticipants: many(warrantProgramParticipants),
}));

export const meetingSummonsAttachmentsRelations = relations(meetingSummonsAttachments, ({ one }) => ({
  file: one(files, {
    fields: [meetingSummonsAttachments.fileId],
    references: [files.id],
  }),
  meeting: one(meetings, {
    fields: [meetingSummonsAttachments.meetingId],
    references: [meetings.id],
  }),
}));

export const meetingConcernsRelations = relations(meetingConcerns, ({ one }) => ({
  articlesOfAssoc: one(articlesOfAssocs, {
    fields: [meetingConcerns.articlesOfAssocId],
    references: [articlesOfAssocs.id],
  }),
  authorizationGroup: one(authorizationGroups, {
    fields: [meetingConcerns.authorizationGroupId],
    references: [authorizationGroups.id],
  }),
  warrantProgram_employeeOptionId: one(warrantPrograms, {
    fields: [meetingConcerns.employeeOptionId],
    references: [warrantPrograms.id],
    relationName: 'meetingConcerns_employeeOptionId_warrantPrograms_id',
  }),
  meeting: one(meetings, {
    fields: [meetingConcerns.meetingId],
    references: [meetings.id],
  }),
  shareIssue: one(shareIssues, {
    fields: [meetingConcerns.shareIssueId],
    references: [shareIssues.id],
  }),
  warrantProgram_warrantProgramId: one(warrantPrograms, {
    fields: [meetingConcerns.warrantProgramId],
    references: [warrantPrograms.id],
    relationName: 'meetingConcerns_warrantProgramId_warrantPrograms_id',
  }),
}));

export const shareIssuesRelations = relations(shareIssues, ({ one, many }) => ({
  meetingConcerns: many(meetingConcerns),
  company: one(companies, {
    fields: [shareIssues.companyId],
    references: [companies.id],
  }),
  meeting: one(meetings, {
    fields: [shareIssues.meetingId],
    references: [meetings.id],
  }),
  snrShareCapitalChange: one(snrShareCapitalChanges, {
    fields: [shareIssues.snrShareCapitalChangeId],
    references: [snrShareCapitalChanges.id],
  }),
  snrAuthorization: one(snrAuthorizations, {
    fields: [shareIssues.snrAuthorizationId],
    references: [snrAuthorizations.id],
  }),
  identity_delContactId: one(identities, {
    fields: [shareIssues.delContactId],
    references: [identities.id],
    relationName: 'shareIssues_delContactId_identities_id',
  }),
  identity_delSignatoryId: one(identities, {
    fields: [shareIssues.delSignatoryId],
    references: [identities.id],
    relationName: 'shareIssues_delSignatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [shareIssues.delSnrCaseId],
    references: [snrCases.id],
  }),
  shareIssueBoardMembers: many(shareIssueBoardMembers),
  shareIssueDocuments: many(shareIssueDocuments),
  shareIssueRegistrations: many(shareIssueRegistrations),
  shareTransactionGroups: many(shareTransactionGroups),
  warrantPrograms: many(warrantPrograms),
}));

export const meetingAgendaTemplatesRelations = relations(meetingAgendaTemplates, ({ one, many }) => ({
  company: one(companies, {
    fields: [meetingAgendaTemplates.companyId],
    references: [companies.id],
  }),
  meetingAgendaTemplateItems: many(meetingAgendaTemplateItems),
}));

export const meetingApprovalsRelations = relations(meetingApprovals, ({ one }) => ({
  meetingParticipant: one(meetingParticipants, {
    fields: [meetingApprovals.meetingParticipantId],
    references: [meetingParticipants.id],
  }),
  meeting: one(meetings, {
    fields: [meetingApprovals.meetingId],
    references: [meetings.id],
  }),
}));

export const meetingDocumentsRelations = relations(meetingDocuments, ({ one }) => ({
  meeting: one(meetings, {
    fields: [meetingDocuments.meetingId],
    references: [meetings.id],
  }),
  file: one(files, {
    fields: [meetingDocuments.fileId],
    references: [files.id],
  }),
}));

export const meetingTodosRelations = relations(meetingTodos, ({ one }) => ({
  meeting: one(meetings, {
    fields: [meetingTodos.meetingId],
    references: [meetings.id],
  }),
  todo: one(todos, {
    fields: [meetingTodos.todoId],
    references: [todos.id],
  }),
}));

export const todosRelations = relations(todos, ({ one, many }) => ({
  meetingTodos: many(meetingTodos),
  identity: one(identities, {
    fields: [todos.identityId],
    references: [identities.id],
  }),
}));

export const meetingParticipantDocumentsRelations = relations(meetingParticipantDocuments, ({ one }) => ({
  file: one(files, {
    fields: [meetingParticipantDocuments.fileId],
    references: [files.id],
  }),
  meetingParticipant: one(meetingParticipants, {
    fields: [meetingParticipantDocuments.meetingParticipantId],
    references: [meetingParticipants.id],
  }),
}));

export const meetingParticipantEmailsRelations = relations(meetingParticipantEmails, ({ one }) => ({
  file: one(files, {
    fields: [meetingParticipantEmails.fileId],
    references: [files.id],
  }),
  email: one(emails, {
    fields: [meetingParticipantEmails.emailId],
    references: [emails.id],
  }),
  meetingParticipant: one(meetingParticipants, {
    fields: [meetingParticipantEmails.meetingParticipantId],
    references: [meetingParticipants.id],
  }),
}));

export const optionsRegistrationDocumentsRelations = relations(optionsRegistrationDocuments, ({ one }) => ({
  file: one(files, {
    fields: [optionsRegistrationDocuments.fileId],
    references: [files.id],
  }),
  optionsRegistration: one(optionsRegistrations, {
    fields: [optionsRegistrationDocuments.optionsRegistrationId],
    references: [optionsRegistrations.id],
  }),
}));

export const optionsSharesRegistrationDocumentsRelations = relations(optionsSharesRegistrationDocuments, ({ one }) => ({
  optionsSharesRegistration: one(optionsSharesRegistrations, {
    fields: [optionsSharesRegistrationDocuments.optionsSharesRegistrationId],
    references: [optionsSharesRegistrations.id],
  }),
  file: one(files, {
    fields: [optionsSharesRegistrationDocuments.fileId],
    references: [files.id],
  }),
}));

export const optionsSharesRegistrationsRelations = relations(optionsSharesRegistrations, ({ one, many }) => ({
  optionsSharesRegistrationDocuments: many(optionsSharesRegistrationDocuments),
  identity_contactId: one(identities, {
    fields: [optionsSharesRegistrations.contactId],
    references: [identities.id],
    relationName: 'optionsSharesRegistrations_contactId_identities_id',
  }),
  identity_signatoryId: one(identities, {
    fields: [optionsSharesRegistrations.signatoryId],
    references: [identities.id],
    relationName: 'optionsSharesRegistrations_signatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [optionsSharesRegistrations.snrCaseId],
    references: [snrCases.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [optionsSharesRegistrations.warrantProgramId],
    references: [warrantPrograms.id],
  }),
  optionsSharesSubscribers: many(optionsSharesSubscribers),
  todos: many(registrationTodoCompletions),
}));

export const optionsSharesSubscriberRepresentativesRelations = relations(
  optionsSharesSubscriberRepresentatives,
  ({ one }) => ({
    optionsSharesSubscriber: one(optionsSharesSubscribers, {
      fields: [optionsSharesSubscriberRepresentatives.optionsSharesSubscriberId],
      references: [optionsSharesSubscribers.id],
    }),
    identity: one(identities, {
      fields: [optionsSharesSubscriberRepresentatives.identityId],
      references: [identities.id],
    }),
  }),
);

export const optionsSharesSubscribersRelations = relations(optionsSharesSubscribers, ({ one, many }) => ({
  optionsSharesSubscriberRepresentatives: many(optionsSharesSubscriberRepresentatives),
  optionsSharesSubscriberDocuments: many(optionsSharesSubscriberDocuments),
  optionsSharesRegistration: one(optionsSharesRegistrations, {
    fields: [optionsSharesSubscribers.optionsSharesRegistrationId],
    references: [optionsSharesRegistrations.id],
  }),
  identity: one(identities, {
    fields: [optionsSharesSubscribers.identityId],
    references: [identities.id],
  }),
}));

export const shareIssueParticipantDocumentsRelations = relations(shareIssueParticipantDocuments, ({ one }) => ({
  shareIssueParticipant: one(shareIssueParticipants, {
    fields: [shareIssueParticipantDocuments.shareIssueParticipantId],
    references: [shareIssueParticipants.id],
  }),
  file: one(files, {
    fields: [shareIssueParticipantDocuments.fileId],
    references: [files.id],
  }),
}));

export const shareIssueParticipantsRelations = relations(shareIssueParticipants, ({ one, many }) => ({
  shareIssueParticipantDocuments: many(shareIssueParticipantDocuments),
  identity_identityId: one(identities, {
    fields: [shareIssueParticipants.identityId],
    references: [identities.id],
    relationName: 'shareIssueParticipants_identityId_identities_id',
  }),
  identity_proxyId: one(identities, {
    fields: [shareIssueParticipants.proxyId],
    references: [identities.id],
    relationName: 'shareIssueParticipants_proxyId_identities_id',
  }),
  shareIssueRegistration: one(shareIssueRegistrations, {
    fields: [shareIssueParticipants.shareIssueRegistrationId],
    references: [shareIssueRegistrations.id],
  }),
}));

export const shareIssueRegistrationDocumentsRelations = relations(shareIssueRegistrationDocuments, ({ one }) => ({
  shareIssueRegistration: one(shareIssueRegistrations, {
    fields: [shareIssueRegistrationDocuments.shareIssueRegistrationId],
    references: [shareIssueRegistrations.id],
  }),
  file: one(files, {
    fields: [shareIssueRegistrationDocuments.fileId],
    references: [files.id],
  }),
}));

export const shareIssueRegistrationsRelations = relations(shareIssueRegistrations, ({ one, many }) => ({
  shareIssueRegistrationDocuments: many(shareIssueRegistrationDocuments),
  identity_contactId: one(identities, {
    fields: [shareIssueRegistrations.contactId],
    references: [identities.id],
    relationName: 'shareIssueRegistrations_contactId_identities_id',
  }),
  shareIssue: one(shareIssues, {
    fields: [shareIssueRegistrations.shareIssueId],
    references: [shareIssues.id],
  }),
  identity_signatoryId: one(identities, {
    fields: [shareIssueRegistrations.signatoryId],
    references: [identities.id],
    relationName: 'shareIssueRegistrations_signatoryId_identities_id',
  }),
  snrCase: one(snrCases, {
    fields: [shareIssueRegistrations.snrCaseId],
    references: [snrCases.id],
  }),
  shareIssueParticipants: many(shareIssueParticipants),
  todos: many(registrationTodoCompletions),
}));

export const snrShareCapitalChangesRelations = relations(snrShareCapitalChanges, ({ one, many }) => ({
  shareIssues: many(shareIssues),
  shareTransactions: many(shareTransactions),
  company: one(companies, {
    fields: [snrShareCapitalChanges.companyId],
    references: [companies.id],
  }),
  shareTransactionGroups: many(shareTransactionGroups),
  warrantPrograms: many(warrantPrograms),
}));

export const shareIssueBoardMembersRelations = relations(shareIssueBoardMembers, ({ one }) => ({
  identity: one(identities, {
    fields: [shareIssueBoardMembers.identityId],
    references: [identities.id],
  }),
  shareIssue: one(shareIssues, {
    fields: [shareIssueBoardMembers.shareIssueId],
    references: [shareIssues.id],
  }),
}));

export const optionsSharesSubscriberDocumentsRelations = relations(optionsSharesSubscriberDocuments, ({ one }) => ({
  optionsSharesSubscriber: one(optionsSharesSubscribers, {
    fields: [optionsSharesSubscriberDocuments.optionsSharesSubscriberId],
    references: [optionsSharesSubscribers.id],
  }),
  file: one(files, {
    fields: [optionsSharesSubscriberDocuments.fileId],
    references: [files.id],
  }),
}));

export const optionsSubscriberRepresentativesRelations = relations(optionsSubscriberRepresentatives, ({ one }) => ({
  identity: one(identities, {
    fields: [optionsSubscriberRepresentatives.identityId],
    references: [identities.id],
  }),
  warrantProgramParticipant: one(warrantProgramParticipants, {
    fields: [optionsSubscriberRepresentatives.warrantParticipantId],
    references: [warrantProgramParticipants.id],
  }),
}));

export const shareIssueDocumentsRelations = relations(shareIssueDocuments, ({ one }) => ({
  file: one(files, {
    fields: [shareIssueDocuments.fileId],
    references: [files.id],
  }),
  shareIssue: one(shareIssues, {
    fields: [shareIssueDocuments.shareIssueId],
    references: [shareIssues.id],
  }),
}));

export const shareTransactionsRelations = relations(shareTransactions, ({ one, many }) => ({
  shareholder_buyerId: one(shareholders, {
    fields: [shareTransactions.buyerId],
    references: [shareholders.id],
    relationName: 'shareTransactions_buyerId_shareholders_id',
  }),
  shareholder_sellerId: one(shareholders, {
    fields: [shareTransactions.sellerId],
    references: [shareholders.id],
    relationName: 'shareTransactions_sellerId_shareholders_id',
  }),
  snrShareCapitalChange: one(snrShareCapitalChanges, {
    fields: [shareTransactions.snrShareCapitalChangeId],
    references: [snrShareCapitalChanges.id],
  }),
  shareTransactionGroup: one(shareTransactionGroups, {
    fields: [shareTransactions.shareTransactionGroupId],
    references: [shareTransactionGroups.id],
  }),
  shareTransactionDocuments: many(shareTransactionDocuments),
}));

export const shareTransactionGroupsRelations = relations(shareTransactionGroups, ({ one, many }) => ({
  shareTransactions: many(shareTransactions),
  company: one(companies, {
    fields: [shareTransactionGroups.companyId],
    references: [companies.id],
  }),
  shareIssue: one(shareIssues, {
    fields: [shareTransactionGroups.shareIssueId],
    references: [shareIssues.id],
  }),
  snrShareCapitalChange: one(snrShareCapitalChanges, {
    fields: [shareTransactionGroups.snrShareCapitalChangeId],
    references: [snrShareCapitalChanges.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [shareTransactionGroups.warrantProgramId],
    references: [warrantPrograms.id],
  }),
}));

export const shareTransactionDocumentsRelations = relations(shareTransactionDocuments, ({ one }) => ({
  file: one(files, {
    fields: [shareTransactionDocuments.fileId],
    references: [files.id],
  }),
  shareTransaction: one(shareTransactions, {
    fields: [shareTransactionDocuments.shareTransactionId],
    references: [shareTransactions.id],
  }),
}));

export const snrBondsRelations = relations(snrBonds, ({ one, many }) => ({
  company: one(companies, {
    fields: [snrBonds.companyId],
    references: [companies.id],
  }),
  warrantPrograms: many(warrantPrograms),
  wiseDependencyBonds: many(wiseDependencyBonds),
}));

export const snrOcrExtractsRelations = relations(snrOcrExtracts, ({ one }) => ({
  snrDocument: one(snrDocuments, {
    fields: [snrOcrExtracts.snrDocumentId],
    references: [snrDocuments.id],
  }),
}));

export const snrDocumentsRelations = relations(snrDocuments, ({ many }) => ({
  snrOcrExtracts: many(snrOcrExtracts),
}));

export const shareSubscriptionsRelations = relations(shareSubscriptions, ({ one }) => ({
  company: one(companies, {
    fields: [shareSubscriptions.companyId],
    references: [companies.id],
  }),
}));

export const webAuthnKeysRelations = relations(webAuthnKeys, ({ one }) => ({
  user: one(users, {
    fields: [webAuthnKeys.userId],
    references: [users.id],
  }),
}));

export const warrantShareholdersRelations = relations(warrantShareholders, ({ one }) => ({
  identity: one(identities, {
    fields: [warrantShareholders.proxyId],
    references: [identities.id],
  }),
  shareholder: one(shareholders, {
    fields: [warrantShareholders.shareholderId],
    references: [shareholders.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [warrantShareholders.warrantProgramId],
    references: [warrantPrograms.id],
  }),
}));

export const wiseDependencyBondsRelations = relations(wiseDependencyBonds, ({ one }) => ({
  snrBond: one(snrBonds, {
    fields: [wiseDependencyBonds.snrBondId],
    references: [snrBonds.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [wiseDependencyBonds.warrantProgramId],
    references: [warrantPrograms.id],
  }),
}));

export const warrantParticipantDocumentsRelations = relations(warrantParticipantDocuments, ({ one }) => ({
  file: one(files, {
    fields: [warrantParticipantDocuments.fileId],
    references: [files.id],
  }),
  warrantProgramParticipant: one(warrantProgramParticipants, {
    fields: [warrantParticipantDocuments.warrantParticipantId],
    references: [warrantProgramParticipants.id],
  }),
}));

export const warrantBoardMembersRelations = relations(warrantBoardMembers, ({ one }) => ({
  identity: one(identities, {
    fields: [warrantBoardMembers.identityId],
    references: [identities.id],
  }),
  warrantProgram: one(warrantPrograms, {
    fields: [warrantBoardMembers.warrantProgramId],
    references: [warrantPrograms.id],
  }),
}));

export const warrantParticipantVestingOccasionsRelations = relations(warrantParticipantVestingOccasions, ({ one }) => ({
  warrantProgramParticipant: one(warrantProgramParticipants, {
    fields: [warrantParticipantVestingOccasions.warrantParticipantId],
    references: [warrantProgramParticipants.id],
  }),
}));

export const meetingAgendaTemplateItemsRelations = relations(meetingAgendaTemplateItems, ({ one }) => ({
  meetingAgendaTemplate: one(meetingAgendaTemplates, {
    fields: [meetingAgendaTemplateItems.meetingAgendaTemplateId],
    references: [meetingAgendaTemplates.id],
  }),
}));

export const fileFolderFieldsRelations = relations(fileFolderFields, ({ many }) => ({
  files: many(files),
}));
